import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';

// Check if running on native platform
export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform();

// Initialize Capacitor plugins
export const initializeCapacitor = async () => {
  if (!isNative) return;

  try {
    // Hide splash screen after app is ready
    await SplashScreen.hide();

    // Set status bar style based on theme
    const theme = localStorage.getItem('theme') || 'light';
    await setStatusBarStyle(theme === 'dark');
  } catch (error) {
    console.error('Failed to initialize Capacitor:', error);
  }
};

// Update status bar style based on theme
export const setStatusBarStyle = async (isDark) => {
  if (!isNative) return;

  try {
    await StatusBar.setStyle({
      style: isDark ? Style.Dark : Style.Light
    });

    if (platform === 'android') {
      await StatusBar.setBackgroundColor({
        color: isDark ? '#020617' : '#ffffff'
      });
    }
  } catch (error) {
    console.error('Failed to set status bar style:', error);
  }
};

// Show/hide status bar
export const setStatusBarVisible = async (visible) => {
  if (!isNative) return;

  try {
    if (visible) {
      await StatusBar.show();
    } else {
      await StatusBar.hide();
    }
  } catch (error) {
    console.error('Failed to toggle status bar:', error);
  }
};

// Get safe area insets for notched devices
export const getSafeAreaInsets = () => {
  if (!isNative) return { top: 0, bottom: 0, left: 0, right: 0 };

  // These CSS env variables are set by Capacitor
  const computedStyle = getComputedStyle(document.documentElement);
  return {
    top: parseInt(computedStyle.getPropertyValue('--safe-area-inset-top') || '0'),
    bottom: parseInt(computedStyle.getPropertyValue('--safe-area-inset-bottom') || '0'),
    left: parseInt(computedStyle.getPropertyValue('--safe-area-inset-left') || '0'),
    right: parseInt(computedStyle.getPropertyValue('--safe-area-inset-right') || '0')
  };
};
